export default __webpack_public_path__ + "static/media/2(World-Trade-Centre).add6b25d.jpg";